export const numericIdFactory = () => {
    let i = 0;
    return () => ++i;
};

export const numericId = numericIdFactory();
